import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Field } from "../../common.model";

@Component({
  selector: "app-feltenkeltkolonne",
  templateUrl: "./feltenkeltkolonne.component.html"
})
export class FeltenkeltkolonneComponent implements OnInit {


  @Input()
  model: any;

  @Input()
  fields: Field[];



  @Input()
  formGroup: FormGroup;

  constructor() { }

  ngOnInit(): void {
  }

}
